import { PageHeader } from "@/components/shared/PageHeader";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { EmptyState } from "@/components/shared/States";
import { PrimaryButton } from "@/components/shared/Buttons";

export default function ExpertSessions() {
  return (
    <div data-testid="page-expert-sessions">
      <PageHeader
        overline="Expert Sessions"
        titleLines={["Learn directly", "from practitioners"]}
        description="Focused sessions with domain experts on current, applied AI topics — practical insight, not theory."
      />

      <section className="bg-white py-24 md:py-32">
        <div className="container-asai">
          <SectionHeading overline="What to expect" title="Applied, current and interactive" />
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {[
              { t: "Live & focused", d: "Concentrated sessions on specific, high-value AI topics." },
              { t: "Practitioner-led", d: "Guidance from people working with AI in the real world." },
              { t: "Actionable", d: "Walk away with insight you can apply immediately." },
            ].map((c) => (
              <div key={c.t} className="rounded-2xl border border-navy/10 bg-lightgrey p-8">
                <h3 className="font-heading text-xl text-navy">{c.t}</h3>
                <p className="mt-3 text-sm text-navy/65">{c.d}</p>
              </div>
            ))}
          </div>

          <div className="mt-16">
            <EmptyState
              title="Upcoming sessions coming soon"
              description="The schedule of expert sessions will be published here. Register your interest to be notified."
            />
            <div className="mt-8 flex justify-center">
              <PrimaryButton to="/contact" withArrow testId="expert-notify-btn">
                Register your interest
              </PrimaryButton>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
